import type { LineClampLevel } from "@circle-react-shared/uikit/SeeMoreLess";
import { SeeMoreLess } from "@circle-react-shared/uikit/SeeMoreLess";
import { DisplayTrixContent } from "@circle-react-uikit/DisplayTrixContent";
import InnerHTML from "dangerously-set-html-content";

import { t } from "@/i18n-js/instance";
import { posts } from "@/react/helpers/urlHelpers";

import { useNavigateToPost } from "../PostModal/hooks/useNavigateToPost";
import { usePostNavigationContext } from "../PostViewList/PostNavigationContext";
import { useCurrentPostHelpers } from "../useCurrentPostHelpers";

export const MinimalTrixContent = () => {
  const { post, isTrixPost } = useCurrentPostHelpers();

  const {
    body_trix_content: bodyTrixContent,
    internal_custom_html: html,
    pinned_at_top_of_space: isPinned,
  } = post;
  const { navigateToPost } = useNavigateToPost();

  const { params, hasNextPage } = usePostNavigationContext();

  let lines: LineClampLevel = 4;

  if (isPinned) {
    lines = 2;
  }

  return (
    <div className="flex w-full flex-col items-start justify-start gap-2">
      <SeeMoreLess lines={lines} hideToggle>
        {isTrixPost && bodyTrixContent && (
          <DisplayTrixContent
            content={bodyTrixContent}
            contentParentPath={posts.show({
              slug: post.slug,
              spaceSlug: post.space_slug,
            })}
          />
        )}
        {html && <InnerHTML key="internal_custom_html" html={html} />}
      </SeeMoreLess>
      <button
        type="button"
        className="text-md text-default hover:text-dark"
        onClick={() => {
          navigateToPost({
            newPost: post,
            params,
            hasNextPage,
          });
        }}
      >
        {t("see_more")}
      </button>
    </div>
  );
};
